<template>
  <div id="add-topik">
    <form action="#" v-on:submit.prevent="submitForm">
      <div class="form-group" id="add-topik-modal-select">
        <label for="inputTopik">{{ data.name }}</label>
        <input
          type="number"
          class="form-control rounded"
          v-model="data.value"
        />
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-primary" :disabled="is_loading">
          Simpan
        </button>
      </div>
    </form>
    <floating-loader-component v-if="is_floating_loading" />
  </div>
</template>
  
  <script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
import floating_loader from "@/views/components/floating_loader.vue";

$.pgNotification = notif;
export default {
  name: "modal_edit_limit",
  props: {
    data: Array,
  },
  components: {
    "floating-loader-component": floating_loader,
  },
  data() {
    return {
      is_loading: false,
      is_floating_loading: false,
    };
  },
  methods: {
    submitForm: function () {
      let self = this;
      self.$store.dispatch("loading", true);
      let params = {
        _id: this.data._id,
        value: parseInt(this.data.value),
      };
      let api = process.env.VUE_APP_API_URL + "limits-update";
      let notif_position = "top";
      this.is_floating_loading = true;
      this.$http
        .post(api, params)
        .then(function (response) {
          if (response.status == 200) {
            self.$parent.$parent.getLimits();
            $("#modalSlideUp").modal("hide");
            self.$store.dispatch("loading", false);
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Limit berhasil diubah.',
                position: notif_position,
                timeout: 5000,
                type: "success",
              })
              .show();
          }
        })
        .catch(function () {
          $("#modalSlideUp").modal("hide");
          self.$store.dispatch("loading", false);
          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan pada saat mengubah Limit!',
              position: notif_position,
              timeout: 5000,
              type: "danger",
            })
            .show();
        })
        .finally(() => {
          this.is_floating_loading = false;
        });
    },
  },
};
</script>
  
  <style scoped>
.form-control {
  -webkit-appearance: button;
  cursor: pointer;
}
#add-topik-modal-select > .select2-container {
  width: 100% !important;
}
</style>